<template>
  <container>
    <mu-flexbox orient="vertical" justify="center" class="wrapper">
      <mu-flexbox-item>
        <img class="transfer-img" src="../../assets/transfer.png" alt="">
      </mu-flexbox-item>
      <mu-flexbox-item class="text-wrapper" style="margin-top: 2rem;">
        <span>结果处理中</span>
        <span>请耐心等待</span>
      </mu-flexbox-item>
    </mu-flexbox>
  </container>
</template>

<style lang="less" rel="stylesheet/less" scoped="">
  .wrapper {
    margin: 12rem auto;

    .transfer-img {
      width: 7.5rem;
    }

    .text-wrapper {
      display: flex;
      flex-direction: column;

      & > span {
        font-size: 1.8rem;
        color: #373f5f;
      }
    }
  }
</style>

<script  >
  import webapi from '../../request/webapi'
  export default {
    name: 'transfer',
    data() {
      return {
        // 当前请求数
        requestNum: 0,
        // 限制请求数
        requestLimit: 3,
        // 请求间隔
        requestTime: 2000,
        // 最新失败url
        faillUrl: ''
      }
    },
    mounted() {
      // 修改history
      (function(window, location) {
        if (location.hash) {
          history.replaceState(null, document.title, location.pathname + "#stealingyourhistory");
          history.pushState(null, document.title, location.pathname);
          window.addEventListener("popstate", function() {
            if (location.hash === "#stealingyourhistory") {
              if (/iPhone|iPad|ios/gi.test(navigator.userAgent)) {
                history.go(-(window.history.length - 2) >= 0 ? -1 : -(window.history.length - 2));
              } else {
                history.go(-(window.history.length - 2) >= 0 ? -1 : -(window.history.length - 2));
              }
            }
          }, false);
        }
      }(window, location));
      if (location.hash === "#stealingyourhistory") {
        window.history.go(-1)
      } else {
        this.init()
      }
    },
    methods: {
      /**
       * 初始化函数
       */
      init() {
        this.requestUrl();
      },
      /**
       * 请求url
       */
      async requestUrl() {
        let requestLimit = this.requestLimit;
        let requestNum = this.requestNum;
        let requestTime = this.requestTime;
        let withdrawApplyNo = window.localStorage.getItem('hxThirdWithdrawApplyNo');
        if (requestNum < requestLimit) {
          try {
            // todo: 添加请求url
            this.requestNum++
            let res = await webapi.hx.withdraw({ withdrawApplyNo })
            console.log('request======>')
            if (res.statusCode === 200 && res.result.data) {
              if (res.result.code !== 1) {
                this.failUrl = res.result.data;
                setTimeout(() => {
                  this.requestUrl()
                }, requestTime)
              } else {
                console.log('跳转至正确页面');
                const url = res.result.data;
                if (!/authorized/.test(url)) {
                  const now = Date.now();
                  this.$reportLog('log', `jumpHx`, '跳转华夏', {
                    input_content: url,
                    action_id: 'log',
                    button_id: `jumpHx`,
                    button_desc: '跳转华夏',
                    page_id: window.nowPage,
                    start_time: now,
                    end_time: now
                  })
                }
                window.location.replace(url);
              }
            } else {
              // 如果服务端返回状态码不正确重新请求
              this.$showToast({text: res.errormsg})
              setTimeout(() => {
                this.requestUrl()
              }, requestTime)
            }
          } catch (e) {
            this.$showToast({text: '请求数据失败'})
          }
        } else {
          console.log('跳转至错误页面')
          if (this.failUrl) {
            window.location.replace(this.failUrl)
          }
          return;
        }
      }
    }
  };
</script>

